<script>
import { Upload, Modal } from 'ant-design-vue'
import { validateImageFile, getFileExt } from '@/utils/imageValidate'

// accept 为通配时仍允许上传的视频格式，它们不走图片解码校验
const VIDEO_EXTS = [
  'mp4',
  'mov',
  'avi',
  'wmv',
  'mpeg',
  'mpg',
  'flv',
  'mkv',
  'm4v'
]

export default {
  props: ['value', 'item', 'mode', 'styles'],
  data() {
    return {
      previewVisible: false,
      previewImage: '',
    }
  },
  methods: {
    // 本次选择的文件是否应该跳过图片安全校验：
    // 1) item.pass 通用放行（历史配置）
    // 2) item.skipImageCheck 显式放行
    // 3) accept 明确指定的不是图片（音频、视频、任意文件等）
    shouldSkipImageCheck(file) {
      const item = this.item || {}
      if (item.pass || item.skipImageCheck) return true
      const accept = String(item.accept || '').toLowerCase()
      if (!accept) return false
      // 明确要图片，必须校验（防止 image/* 里混进 svg）
      if (accept.indexOf('image') !== -1) return false
      // 通配场景（图片/视频混传）：视频不按图片规则校验
      if (accept === '*' || accept === '*/*') {
        return VIDEO_EXTS.indexOf(getFileExt(file.name)) !== -1
      }
      return true
    },
    handlePreview(file) {
      if (!file.url) return
      this.previewImage = file.url
      this.previewVisible = true
    },
    getImgUrl(list) {
      // '?imageView2/0/format/jpg/q/75'
      const arr = []
      const { url } = JSON.parse(localStorage.getItem('qiniu')) || {}
      list.forEach((e, i) => {
        if (e.status == 'done') {
          if (this.item.multiple && this.item.maxLength && +this.item.maxLength < i + 1) {
            this.$message.warning(`限制${this.item.maxLength}张`)
            return arr.join(',')
          }
          if (e.hash) {
            arr.push(url + e.hash)
          } else if (e.url) {
            arr.push(e.url)
          } else {
            if (e.response && e.response.hash) {
              arr.push(url + e.response.hash)
            }
          }
        }
      })

      return arr.join(',')
    },
    getFileList(url) {
      if (Array.isArray(url)) return url
      if (!url) return []
      return url
        .split(',')
        .filter((e) => e)
        .map((e) => {
          if (!e) return
          const name = e.split('?')[0].split('/')[3]
          return {
            uid: 'vc-upload-' + name,
            name,
            status: 'done',
            url: e,
            thumbUrl: e,
          }
        })
    },
    handleChange(data) {
      let arr = data.fileList.slice(0, 20)
      if (arr.some((e) => e.status == 'uploading')) {
        this.$emit('change', arr)
      } else {
        this.$emit('change', this.getImgUrl(arr))
      }
    },
    renderButton() {
      return (
        <div>
          <a-icon type="plus" />
          <div class="ant-upload-text">上传</div>
        </div>
      )
    },
    renderUploadItem(file) {
      if (file.indexOf('mp4') !== -1) {
        return <video src={file} />
      }
      return this.isImage(file) ? <img src={file} /> : <a href={file} target="_blank">{file.split('/').pop()}</a>
    },
    isImage(url) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp']
      const ext = url.toLowerCase().substring(url.lastIndexOf('.'))
      return imageExtensions.includes(ext)
    },
    beforeUpload(file) {
      if (this.item.pass) return true
      const isLt4M = file.size / 1024 / 1024 < 4
      if (!isLt4M) {
        this.$message.error('资源文件体积不能超过4M')
        return false
      }
      // 需要上传视频、音频等非图片资源的场景，跳过图片校验
      if (this.shouldSkipImageCheck(file)) return true
      // 异步校验：扩展名 / 文件头魔数 / 可执行标记 / 浏览器真实解码
      return validateImageFile(file, {
        maxSize: 4 * 1024 * 1024,
        ...(this.item.imageValidate || {})
      }).then(res => {
        if (res.ok) return file
        this.$message.error(res.message)
        return Promise.reject(new Error(res.message))
      })
    },
  },
  render() {
    const { token } = JSON.parse(localStorage.getItem('qiniu')) || {}
    return (
      <div>
        <Upload
          name="file"
          action="//upload.qiniup.com/"
          list-type="picture-card"
          fileList={this.getFileList(this.value)}
          accept={this.item.accept || 'image/*'}
          disabled={this.mode == 'detail' || this.item.disabled}
          class="uploader"
          data={{ token }}
          onChange={this.handleChange}
          style={this.styles}
          renderUploadItem={this.renderUploadItem}
          beforeUpload={this.beforeUpload}
          onPreview={this.handlePreview}
          multiple={this.item.multiple}
        >
          {(this.getFileList(this.value) || []).length < (this.item.maxLength || 1) && this.renderButton()}
        </Upload>

        <Modal visible={this.previewVisible} footer={null} onCancel={() => (this.previewVisible = false)}>
          {this.previewImage.indexOf('mp4') != -1 ? (
            <video src={this.previewImage} style={{ width: '100%', height: '100%', objectFit: 'fill' }} controls />
          ) : this.isImage(this.previewImage) ? (
            <img alt="example" style="width: 100%" src={this.previewImage} />
          ) : (
            <a href={this.previewImage} target="_blank" style="display: block; padding: 20px; word-break: break-all;">{this.previewImage}</a>
          )}
        </Modal>
      </div>
    )
  },
}
</script>
<style lang="less" scoped>
.uploader {
  margin-left: 0px !important;
}
/deep/.ant-upload-list-item-thumbnail img{
    -o-object-fit: contain;
    object-fit: contain;
}
</style>
